import React from 'react';
import { bindActionCreators }  from 'redux';
import { connect }  from 'react-redux';
import Translator from 'bazinga-translator';

import * as PopupActions from '../actions/popup_actions';

class CreateNew extends React.Component {
    constructor() {
        super();
        this.handleNewPopup = this.handleNewPopup.bind(this);
    }

    handleNewPopup(e){
        const {popupActions} = this.props;
        e.preventDefault();
        popupActions.setNewPopup();
    }

    render() {
        return (
        <div className="box-drafts -new">
            <div className="box-picture__pen"></div>
            <h2>{Translator.trans('drafts.new_box_header', [], 'app')}</h2>
            <p>{Translator.trans('drafts.new_box_desc', [], 'app')}</p>
            <a className="btn" href="#" onClick={this.handleNewPopup}>{Translator.trans('drafts.new_box_button', [], 'app')}</a>
        </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        popup: state.popup
    }
}

function mapDispatchToProps(dispatch) {
    return {
        popupActions : bindActionCreators(PopupActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNew);


// WEBPACK FOOTER //
// ./src/_app/drafts/containers/create_new.jsx